import React, { useEffect, useState } from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import LoadingIndicatorHeader from "../loading-indicator/loading-indicator-header";
import LoadingIndicatorText from "../loading-indicator/loading-indicator-text";
import util from "../util/util";
import InviteFormButtons from "./invite-form-buttons";

const jQuery = window.jQuery;

export default function InviteForm(props) {
  // id of the invite we are editing (0 means new invite to create);
  const [id, setId] = useState(0);
  const [loaded, setLoaded] = useState(false);
  // options to display in a SELECT field;
  const [roles, setRoles] = useState([]);
  // array used to control the SELECT fields for invites
  // (does not contain the values to pass to Django);
  const [invites, setInvites] = useState([]);
  const [stationName, setStationName] = useState("");
  const [stationGroups, setStationGroups] = useState([]);

  useEffect(() => {
    const inviteId = props.params ? Number(props.params.id) : 0;

    // get the invite data to display in the form;
    const getInvite = () => {
      if (inviteId === 0) {
        setInvites([
          {
            email: ``,
            role: ``
          }
        ]);
      } else {
        util.getStationInvite(inviteId).then(data => {
          setTimeout(() => {
            setId(inviteId);
            setInvites([
              {
                email: data.email,
                role: data.group.id
              }
            ]);
          }, util.delayDetail);
        });
      }
    };

    getStation();
    getRoles();
    getInvite();
    setLoaded(true);
  }, [props]);

  // get station information to display above the form;
  const getStation = () => {
    util.getStation().then(data => {
      setTimeout(() => {
        setStationName(data.name);
        setStationGroups(data.group_counts);
      }, util.delayDetail);
    });
  };

  // get the role options to display in the SELECT;
  const getRoles = () => {
    util.getRoles().then(data => {
      setRoles(data.results);
    });
  };

  // push an empty value into the invites array;
  // this way a new INPUT will appear for the user to add the new value;
  const addInvite = () => {
    const invitesArray = Array.from(invites);

    invitesArray.push({
      email: ``,
      role: ``
    });

    setInvites(invitesArray);

    document.querySelector(`#email${invites.length - 1}`).focus();
  };

  // remove the index from the invite array;
  // this will remove the form fields;
  const removeInvite = index => {
    const invitesArray = Array.from(invites);

    invitesArray.splice(index, 1);

    setInvites(invitesArray);
  };

  // change a value in the invites array;
  const changeInviteValue = (value, target, prop) => {
    const invitesArray = Array.from(invites);

    invitesArray[target][prop] = value;

    setInvites(invitesArray);
  };

  // save the data;
  const onSubmit = () => {
    const requests = []; // container for our promises;
    const $button = jQuery(`.btn-primary`);

    // fire off an Ajax call per user, creating an invite;
    invites.forEach((invite, index) => {
      const email = invites[index].email;
      const role = invites[index].role;

      // only if the user filled out the form;
      // resend is a PUT, new is a POST;
      // the util function determines that based on id;
      if (email && role) {
        requests.push(
          util.saveInvite(id, {
            email: email,
            group: role
          })
        );
      }
    });

    // dont do anything if there aren't invites to process;
    if (requests.length) {
      // put the button into a processing state;
      $button.button(`loading`);

      // when all the Ajax calls resolve;
      // go to the list;
      jQuery.when
        .apply(jQuery, requests)
        .fail(() => {
          // on fail, reset the button on fail so it can be clicked again;
          setTimeout(() => {
            $button.button(`reset`);
          }, util.delayForm);
        })
        .then(() => {
          // on success, go to the invite list;
          setTimeout(() => {
            browserHistory.push(util.returnInviteListUrl());
          }, util.delayForm);
        });
    }
  };

  // cancel this action (do nothing and go somewhere else);
  const onCancel = () => {
    browserHistory.push(util.returnInviteListUrl());
  };

  if (loaded === false) {
    return <LoadingIndicatorHeader />;
  } else {
    return (
      <form className="invite-form">
        <div className="row">
          <div className="col-xs-6">
            <h4 className="page__title">Invite Users</h4>
          </div>

          <div className="col-sm-6 hidden-xs">
            <InviteFormButtons
              onCancel={() => onCancel()}
              onSubmit={() => onSubmit()}
            />
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-xs-6 col-sm-3">
            <h4 className="page__header">
              <strong>Station</strong>
            </h4>
            {stationName ? (
              <p>{stationName}</p>
            ) : (
              <p>
                <LoadingIndicatorText />
              </p>
            )}
          </div>
          <div className="col-xs-6 col-sm-9">
            <div className="row">
              {stationGroups &&
                stationGroups.map((group, index) => {
                  return (
                    <div className="col-sm-4" key={index}>
                      <h4 className="page__header">
                        <strong>{group.name}</strong>
                      </h4>
                      <p>{group.count}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        <hr />

        <label className="control-label">
          {id === 0 ? `Add` : `Manage`} Invite
          {invites.length > 1 ? `(s)` : ``}
        </label>
        <div className="well">
          {invites.map((invite, index) => (
            <div className="form-inline form-group" key={index}>
              <hr className={index === 0 ? `hidden` : `visible-xs-block`} />

              <div className="form-group">
                <label className="control-label" htmlFor={`email${index}`}>
                  Email
                </label>
                <input
                  type="email"
                  id={`email${index}`}
                  className="form-control"
                  value={invite.email}
                  onChange={e =>
                    changeInviteValue(e.target.value, index, `email`)
                  }
                />
              </div>

              <div className="form-group">
                <label className="control-label" htmlFor={`role${index}`}>
                  Role
                </label>
                <select
                  id={`role${index}`}
                  className="form-control"
                  value={invite.role}
                  onChange={e =>
                    changeInviteValue(e.target.value, index, `role`)
                  }
                >
                  <option disabled value={null}></option>
                  {roles.map((role, i) => {
                    return (
                      <option value={role.id} key={i}>
                        {role.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <button
                type="button"
                className={index === 0 ? `hidden` : `btn btn-default`}
                onClick={() => removeInvite(index)}
              >
                <i className="fa fa-trash-o" aria-hidden="true"></i>
                Delete
              </button>
            </div>
          ))}
        </div>

        {id === 0 ? (
          <button
            type="button"
            className="btn btn-default"
            onClick={() => addInvite()}
          >
            <i className="fa fa-plus" aria-hidden="true"></i>
            Add Another Invite
          </button>
        ) : null}

        <hr />

        <InviteFormButtons
          onCancel={() => onCancel()}
          onSubmit={() => onSubmit()}
        />
      </form>
    );
  }
}

InviteForm.propTypes = {
  params: PropTypes.object
};
